module.exports = __webpack_public_path__ + "img/sduty.7f9a0274.jpg";